<div class="card">
    <h1>Probe mismatches over time</h1>
    <div style="text-align: center;">
        <p-progressSpinner *ngIf="showSpinner"></p-progressSpinner>
    </div>
    <p-chart *ngIf="!showSpinner" type="line" [data]="data" height="80vh"></p-chart>
</div>
